module.exports = __webpack_public_path__ + "img/cloth_g1_shirt_03.7f4fcf4e.svg";